import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
// import AdvancedFilters from 'components/AdvancedFilters';
import ErrorBoundary from 'components/common/ErrorBoundary';
import DebounceTextInput from 'components/DebounseTextInput';
import {
  getInactiveSubscriberFilter,
  getPlanExpiringFilter,
  getSubscriberFilter,
} from 'pages/Vendor/constants';
import CommonForeignVendorTable from './components/CommonForeignVendorTable';
import SubscriberCheckboxLists from '../SubscriberCheckboxLists';


const CommonForeignVendor = ({
  handleClickEdit,
  toggleDeleteRecord,
  kycStatus = 'ALL',
  type,
  drawerEmailToggle,
  toggleDeactivatePlan,
  subscriberType = 'All',
  planExpiringType = 0,
  osType = 'All',
  traderType = 'All',
  dateRange,
}) => {
  const [searchString, setSearchString] = useState('');
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [checkboxes, setCheckboxes] = useState([
    // {
    //   id: 'all',
    //   label: 'All',
    //   checked: false,
    // },
    {
      id: 'freeSubscribers',
      label: 'Free Trial',
      checked: false,
    },
    {
      id: 'paidSubscribers',
      label: 'Paid',
      checked: false,
    },
    {
      id: 'polylite',
      label: 'Poly-Lite',
      checked: false,
    },
    {
      id: 'polymax',
      label: 'Poly-Max',
      checked: false,
    },
  ]);

  const getCheckedIds = () => {
    if (
      subscriberType === 'subscribers' ||
      subscriberType === 'expireSubscribers'
    )
      return checkboxes
        .filter((checkbox) => checkbox.checked)
        .map((checkbox) => checkbox.id);

    return [];
  };

  const handleChange = (value) => {
    setSearchString(value);
  };

  // useEffect(() => {
  //   setFilterValue([
  //     { key: 'kycStatus', value: kycStatus, type: 'STRING', op: 'EQ' },
  //     {
  //       key: 'traderSearchFilter',
  //       // joinAttributeName: '',
  //       value: searchString,
  //       type: 'STRING',
  //       op: 'LIKE_OR_NULL',
  //     },
  //     // ...getPlanExpiringFilter(planExpiringType),
  //     // ...getSubscriberFilter([subscriberType, ...getCheckedIds()]),
  //   ]);
  // }, [kycStatus, searchString]);

  return (
    <ErrorBoundary>
      <Row>
        <Col
          className={`text-end vendor-search-controls ${
            isSearchActive ? 'search-active' : ''
          }`}
          sm={6}
        >

          <DebounceTextInput
            onInputChange={handleChange}
            delay={500} // Set your desired delay in milliseconds
            value={searchString}
            classWrapper="right-search"
            placeholder="Search by name or company name or phone no."
            positionTop="-30px"
            callBackFocus={() => setIsSearchActive(true)}
            callBackBlur={(value) => setIsSearchActive(Boolean(value))}
          />
        </Col>
      </Row>
      <SubscriberCheckboxLists
        subscriberType={subscriberType}
        checkboxes={checkboxes}
        setCheckboxes={setCheckboxes}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
      />
      <CommonForeignVendorTable
        subscriberType={
          subscriberType === 'expireSubscribers'
            ? getInactiveSubscriberFilter([subscriberType, ...getCheckedIds()])
            : getSubscriberFilter([subscriberType, ...getCheckedIds()])
        }
        // {getSubscriberFilter(subscriberType, getCheckedIds())}
        planExpiringType={getPlanExpiringFilter(planExpiringType)}
        osType={osType}
        traderType={traderType}
        kycStatus={kycStatus}
        searchString={searchString}
        handleClickEdit={handleClickEdit}
        toggleDeleteRecord={toggleDeleteRecord}
        type={type}
        // setAllRows={setAllRows}
        drawerEmailToggle={drawerEmailToggle}
        toggleDeactivatePlan={toggleDeactivatePlan}
        rowSelection={rowSelection}
        setRowSelection={setRowSelection}
        dateRange={dateRange}
      />
    </ErrorBoundary>
  );
};

export default CommonForeignVendor;
